<!--
 * @Description:
 * @Author: xz
 * @Date: 2023-07-28 14:44:18
 * @LastEditTime: 2024-01-04 09:24:03
 * @LastEditors: xz
-->
<template>
    <!-- <div style="width:20vw; height: 100%">
        <div id="tupuLeft"></div>
    </div> -->
    <div id="tupuLeft"></div>
</template>
<script>
// import ForceGraph3D from "3d-force-graph";
// import {
//     CSS2DRenderer,
//     CSS2DObject,
// } from "three/examples/jsm/renderers/CSS2DRenderer.js";
// import G6 from '@antv/g6';
import * as echarts from 'echarts';
export default {
    components: {
    },
    data() {
        return {
            selectPoint: [],
            cityOptions: [],
            checkedCities: [],
            checkAll: false,
            isIndeterminate: false,
            form: {
                id: "",
                name: "",
                label: [],
                nodes: [],
            },
            title: "",
            dialogVisible: false, //点击弹框出现
            isShowNodeMenuPanel: false,
            //   nodeMenuPanelPosition: { x: 0, y: 0 },
            currentNode: {},
            isShowNodeTipsPanel: false,
            isShowCodePanel: false,
            nodeMenuPanelPosition: { x: 0, y: 0 },
            graphOptions: {
                allowSwitchLineShape: true,
                allowSwitchJunctionPoint: true,
                defaultJunctionPoint: "border",
                // 这里可以参考"Graph 图谱"中的参数进行设置
            },
            pointObject: {},

            nodes: [
                { name: "水文指标", draggable: true, },
                { name: "水文情势", draggable: true, },
                { name: `发生时间、持续时间、频率、流量、变化率`, draggable: true, },
                { name: "生态流量", draggable: true, },
                { name: "生态系统", draggable: true, },
                { name: "生境、生物", draggable: true, },
                { name: "生态指标", draggable: true, },
                { name: "生态流量计算方法", draggable: true, },
            ],
            lines: [
                { source: 0, target: 1, value: "指标" },
                { source: 0, target: 7, value: "输入" },
                { source: 0, target: 2, value: "衡量" },
                { source: 1, target: 2, value: "父子类" },
                { source: 1, target: 4, value: "影响" },
                { source: 2, target: 3, value: "印象因素" },
                { source: 7, target: 3, value: "" },
                { source: 6, target: 8, value: "输入" },
                { source: 6, target: 4, value: "指标" },
                { source: 4, target: 1, value: "需求" },
                { source: 4, target: 5, value: "父子类" },
                { source: 5, target: 3, value: "影响因素" },
                { source: 6, target: 5, value: "衡量" },
            ],
        };
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            let that = this
            var myChart = echarts.init(document.getElementById('tupuLeft'));
            myChart.setOption({
                animationDurationUpdate: 1500,
                animationEasingUpdate: 'quinticInOut',
                label: {
                    normal: {
                        show: true,
                        textStyle: {
                            fontSize: 12
                        },
                    }
                },
                legend: {
                    x: "center",
                    show: false,
                    data: ["夫妻", "战友", '亲戚']
                },
                series: [

                    {
                        type: 'graph',
                        layout: 'force',
                        symbolSize: 45,
                        focusNodeAdjacency: true,
                        roam: true,



                        categories: [{
                            name: '水文指标',
                            itemStyle: {
                                normal: {
                                    color: "#009800",
                                }
                            }
                        }, {
                            name: '水文情势',
                            itemStyle: {
                                normal: {
                                    color: "#4592FF",
                                }
                            }
                        }, {
                            name: '发生时间、持续时间、频率、流量、变化率',
                            itemStyle: {
                                normal: {
                                    color: "#3592F",
                                }
                            }
                        }],
                        label: {
                            normal: {
                                show: true,
                                textStyle: {
                                    fontSize: 12
                                },
                            }
                        },
                        force: {
                            repulsion: 1000
                        },
                        edgeSymbolSize: [4, 50],
                        edgeLabel: {
                            normal: {
                                show: true,
                                textStyle: {
                                    fontSize: 10
                                },
                                formatter: "{c}"
                            }
                        },
                        data: this.nodes,
                        links: this.lines,
                        lineStyle: {
                            normal: {
                                opacity: 0.9,
                                width: 1,
                                curveness: 0
                            }
                        }
                    }
                ]
            });
            myChart.on('click', function (params) {
                console.log(params);
                if (params.dataType == 'node') {
                    that.$emit('checkText', params.name)
                }
            });
        }
    },
};
</script>

<style scoped>
#tupuLeft {
    width: 30vw;
    height: 100vh;
    z-index: 10000000;
}



.node-labels {
    padding: 1px 4px;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Tupu/comp/tupu_left.vue